import {PushNotifications} from '@capacitor/push-notifications'

export default {
    async getDeviceToken(successCallback){
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }
        if (permStatus.receive !== 'granted') {
            throw new Error('User denied permissions!');
        }

        // Register with Apple / Google to receive push via APNS/FCM
        await PushNotifications.register();

        // Listen for success.. and get token
        await PushNotifications.addListener('registration', token=>{
            successCallback({token: token.value});
            return {token: token.value};
        });

        // Some issue with our setup and push will not work
        await PushNotifications.addListener('registrationError', error=>{
            window.console.error(error);
            throw new Error(error);
        });
        
        return true;
    },
}